import { Trans, useTranslation } from 'react-i18next';
import { useState } from 'react';

import { getBusiness } from 'pages/Profile/selectors';
import { useAppSelector } from 'hooks/redux';
import Button from 'components/Button';
import Modal from 'components/Modal';
import Link from 'components/Link';

const CapitalProductGetStartedModal = ({ onClose }) => {
  const { t } = useTranslation('dashboard');

  const { oatFiCompanyName } = useAppSelector(getBusiness);

  const [imageSrc, setImageSrc] = useState(
    `/assets/images/freightPartners/${(oatFiCompanyName ?? '')
      .toLowerCase()
      .replace(/\s+/g, '-')}.png`,
  );

  return (
    <Modal
      isOpen={true}
      maxWidth="640px"
      isOverlayDisabled
      hideCross
      closeModal={onClose}
    >
      <img
        src={imageSrc}
        alt="Freightos"
        className="short:h-[200px] h-[256px] w-full object-cover"
        onError={() =>
          setImageSrc('/assets/images/freightPartners/default.png')
        }
      />
      <div className="px-12 py-12 short:py-8 flex flex-col gap-6">
        <h2 className="text-2xl short:text-3xl font-bold text-gray-800">
          {t('progress.capital.getStartedModalTitle')}
        </h2>

        <p className="text-sm text-gray-700">
          <Trans
            i18nKey="dashboard:progress.capital.getStartedModalText1"
            values={{ name: oatFiCompanyName }}
          >
            text<b>bold</b>text
          </Trans>
        </p>

        <div className="flex flex-col gap-3">
          <p className="text-sm font-semibold">
            {t('progress.capital.getStartedModalStepTitle')}
          </p>

          {Array.from({ length: 5 }, (_, index) => (
            <div key={index} className="flex items-center gap-3">
              <span className="w-5 h-5 flex items-center justify-center border border-gray-200 rounded-full bg-gray-100 text-xs font-medium text-gray-800">
                {index + 1}
              </span>
              <p className="text-sm">
                <Trans
                  i18nKey={`dashboard:progress.capital.getStartedModalStep${
                    index + 1
                  }`}
                >
                  text<b>bold</b>text
                </Trans>
              </p>
            </div>
          ))}
        </div>

        <p className="text-xs text-gray-500">
          <Trans i18nKey="dashboard:progress.capital.getStartedModalText2">
            text<b>bold</b>text
          </Trans>{' '}
          <Link href="https://oatfi.com/" target="_blank">
            OatFi.com
          </Link>
          .
        </p>

        <Button
          onClick={onClose}
          className="self-start font-semibold"
          heightClass="h-11"
        >
          {t('progress.capital.getStartedModalButton')}
        </Button>
      </div>
    </Modal>
  );
};

export default CapitalProductGetStartedModal;
